import React, { useMemo } from 'react'
import numeral from 'numeral'
import { createColumnHelper, getCoreRowModel, useReactTable } from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import styles from './styles.module.scss'

import Table from '../../../Invoices/Table'

import { getCurrency } from '../../../../helpers/currencies'

const columnHelper = createColumnHelper()

const Placeholder = () => {
  const { t } = useTranslation()
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        aria-hidden="true"
        className="lucide lucide-users h-8 w-8"
      >
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87" />
        <circle cx={9} cy={7} r={4} />
      </svg>
      <div style={{color: '#333945', marginBottom : 4}}>{t('No employees worked during this period')}</div>
      <div>{t('Pick a period to view')}</div>
    </div>
  )
}

const ProfitabilityEmployees = ({data}) => {
  const { t } = useTranslation()

  const companyInfo = useSelector(state => state.company.companyInfo)
  const currency = getCurrency(companyInfo?.currency)
    
  const columns = useMemo(() => ([
    columnHelper.accessor('name', {
      id: 'name',
      header: t('Employee'),
      enableSorting: false,
      cell: ({ getValue }) => getValue()
    }),
    columnHelper.accessor('group', {
      id: 'group',
      header: t('Group'),
      enableSorting: false,
      cell: ({ getValue }) => getValue()
    }),
    columnHelper.accessor('total_hours', {
      id: 'total_hours',
      enableSorting: false,
      cell: ({ getValue }) => numeral(getValue() || 0).format('0.00'),
      header: t('Hours'),
    }),
    columnHelper.accessor('total_cost', {
      id: 'total_cost',
      enableSorting: false,
      cell: ({ getValue }) => `${numeral(getValue() || 0).format('0.00')} ${currency.symbol}`,
      header: t('Internal cost'),
    }),
    columnHelper.accessor('billable_cost', {
      id: 'billable_cost',
      enableSorting: false,
      cell: ({ getValue }) => {
        const color = getValue() > 0 ? '#10b981' : getValue() < 0 ? '#ef4444' : '#374151'
        return <span style={{color: color}}>{`${numeral(getValue() || 0).format('0.00')} ${currency.symbol}`}</span>
      },
      header: t('Billable rate'),
    }),
    columnHelper.display({
      id: 'contribution',
      enableSorting: false,
      cell: ({ row }) => {
        const value = numeral(row.original.billable_cost - row.original.total_cost).value()
        const color = value > 0 ? '#10b981' : value < 0 ? '#ef4444' : '#374151'
        return <span style={{color: color}}>{`${numeral(value).format('0.00')} ${currency.symbol}`}</span>
      },
      header: t('Contribution'),
    }),
  ]), [t])

  const table = useReactTable({
    data: data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    // getRowId: row => String(row.place_id),
  })

  return (
    <div className={styles.container}>
      <Table
        table={table}
        columns={columns}
        placeholder={<Placeholder />}
        headerClassName={styles.tableHeader}
        tableClassName={styles.table} />
    </div>
  )
}

export default ProfitabilityEmployees
